/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Tile_Csv_HintInputs */

const cs_import_tile_csv_hint = /** @type {(inputs: Import_Tile_Csv_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitosti nebo klienti z CSV s mapováním sloupců.`)
};

const en_import_tile_csv_hint = /** @type {(inputs: Import_Tile_Csv_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties or clients from a CSV with column mapping.`)
};

/**
* | output |
* | --- |
* | "Properties or clients from a CSV with column mapping." |
*
* @param {Import_Tile_Csv_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_tile_csv_hint = /** @type {((inputs?: Import_Tile_Csv_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Tile_Csv_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_tile_csv_hint(inputs)
	return cs_import_tile_csv_hint(inputs)
});